(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giving-faq-compact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kipritii-giving-contact')) {
    customElements.define('kipritii-giving-contact', class extends HTMLElement {
      static scrollLocks = new Set();
      static previousOverflow = '';

      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.opener = this.querySelector('[data-contact-open]');
        if (!this.dialog || !this.form || !this.opener) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.storageKey = 'kipritii-giving-contact-submitted';
        this.lastTrigger = null;
        this.backdropPress = false;

        if (typeof this.dialog.showModal !== 'function') {
          this.setAttribute('data-inline-form', '');
          this.dialog.setAttribute('open', '');
          return;
        }

        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.addEventListener('click', event => {
          event.preventDefault();
          this.open(this.opener);
        }, { signal });

        this.querySelector('[data-contact-close]').addEventListener('click', () => this.close(), { signal });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close();
        }, { signal });
        this.dialog.addEventListener('close', () => this.restorePage(), { signal });
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropPress = this.isBackdrop(event);
        }, { signal });
        this.dialog.addEventListener('pointerup', event => {
          if (this.backdropPress && this.isBackdrop(event)) this.close();
          this.backdropPress = false;
        }, { signal });
        this.dialog.addEventListener('pointercancel', () => { this.backdropPress = false; }, { signal });

        // Browser validation and Shopify's normal contact submission remain intact.
        this.form.addEventListener('submit', () => {
          try { sessionStorage.setItem(this.storageKey, this.form.id); } catch (_) {}
        }, { signal });

        const status = this.querySelector('[data-contact-status]');
        const targeted = window.location.hash.slice(1) === this.form.id;
        let submittedHere = false;
        try { submittedHere = sessionStorage.getItem(this.storageKey) === this.form.id; } catch (_) {}
        if (targeted || (status && submittedHere)) {
          this.open(this.opener);
          if (status) {
            status.focus({ preventScroll: true });
            try {
              if (sessionStorage.getItem(this.storageKey) === this.form.id) sessionStorage.removeItem(this.storageKey);
            } catch (_) {}
          }
        }
      }

      open(trigger) {
        if (!this.controller || this.dialog.open) return;
        this.lastTrigger = trigger || this.opener;
        this.dialog.showModal();
        const cls = this.constructor;
        if (!cls.scrollLocks.size) cls.previousOverflow = document.documentElement.style.overflow;
        cls.scrollLocks.add(this);
        document.documentElement.style.overflow = 'hidden';
        this.opener.setAttribute('aria-expanded', 'true');
        const focusTarget = this.querySelector('[data-contact-status]') || this.dialog.querySelector('input:not([type="hidden"]), textarea');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      close() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom;
      }

      restorePage() {
        const cls = this.constructor;
        if (cls.scrollLocks.delete(this) && !cls.scrollLocks.size) {
          document.documentElement.style.overflow = cls.previousOverflow;
        }
        if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
        if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus({ preventScroll: true });
        this.lastTrigger = null;
      }

      disconnectedCallback() {
        this.close();
        this.restorePage();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giving-in-action"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target && event.target.closest ? event.target.closest('.kgia-item') : null;
  const gallery = item && item.closest('.kgia-gallery--swipe');
  if (!gallery || gallery.scrollWidth <= gallery.clientWidth + 1) return;
  const left = gallery.scrollLeft + item.getBoundingClientRect().left - gallery.getBoundingClientRect().left
    - (parseFloat(getComputedStyle(gallery).paddingLeft) || 0);
  gallery.scrollTo({ left, behavior: 'auto' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giving-shelter-list"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('kipritii-shelter-list')) return;

  class KipritiiShelterList extends HTMLElement {
    static feeds = new Map();
    static collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

    static text(value) {
      return value == null ? '' : String(value).trim();
    }

    static validMonth(value) {
      return /^\d{4}-(0[1-9]|1[0-2])$/.test(this.text(value));
    }

    static validDate(value) {
      const raw = this.text(value);
      if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(raw)) return false;
      const date = new Date(`${raw}T12:00:00Z`);
      return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === raw;
    }

    static dateLabel(date, month = '') {
      const normalizedDate = this.text(date);
      const normalizedMonth = this.text(month);
      const exactDate = this.validDate(normalizedDate);
      if (!exactDate && !this.validMonth(normalizedMonth)) return '';
      const value = new Date(`${exactDate ? normalizedDate : `${normalizedMonth}-01`}T12:00:00Z`);
      const options = { month: 'long', year: 'numeric', timeZone: 'UTC' };
      if (exactDate) options.day = 'numeric';
      return new Intl.DateTimeFormat('en-US', options).format(value);
    }

    static normalize(value) {
      return this.text(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ');
    }

    static safeURL(value, base = window.location.href) {
      const raw = this.text(value);
      if (!raw || !/^(https?:\/\/|\/\/|\/)/i.test(raw)) return '';
      try {
        const url = new URL(raw, base);
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
      } catch (_) {
        return '';
      }
    }

    static validateFeed(feed, type, expectedPage) {
      if (!feed || feed.version !== 3 || feed.type !== type || !Array.isArray(feed.entries)) {
        throw new Error('Invalid shelter feed');
      }
      const page = Number(feed.page);
      const pages = Math.max(1, Number(feed.pages));
      const total = Number(feed.total);
      if (!Number.isInteger(page) || page < 1 || page !== expectedPage || !Number.isInteger(pages) || pages < page || !Number.isInteger(total) || total < 0 || !feed.page_param) {
        throw new Error('Invalid shelter pagination');
      }
      return { ...feed, page, pages, total };
    }

    static parseHTML(html, type, page) {
      const match = html.match(/<script\b(?=[^>]*\bdata-ksl-feed\b)[^>]*>([\s\S]*?)<\/script\s*>/i);
      if (!match) throw new Error('Shelter feed not found');
      return this.validateFeed(JSON.parse(match[1]), type, page);
    }

    static async fetchPage(context, page, pageParam) {
      const url = new URL(context.url);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', context.sectionId);
      url.searchParams.set(pageParam, String(page));
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Shelter page request failed');
        return this.parseHTML(await response.text(), context.type, page);
      } finally {
        clearTimeout(timer);
      }
    }

    static async collect(seed, context) {
      const first = seed.page === 1 ? this.validateFeed(seed, context.type, 1) : await this.fetchPage(context, 1, seed.page_param);
      const batches = [first.entries];
      // Fetch all record pages, including entries beyond the first 50/100.
      // The two page sections share this promise; only visible rows enter the DOM.
      for (let page = 2; page <= first.pages; page += 2) {
        const numbers = [page];
        if (page + 1 <= first.pages) numbers.push(page + 1);
        const feeds = await Promise.all(numbers.map(number => this.fetchPage(context, number, first.page_param)));
        for (const feed of feeds) {
          if (feed.total !== first.total || feed.pages !== first.pages) throw new Error('Shelter records changed while loading');
          batches.push(feed.entries);
        }
      }
      const seen = new Map();
      for (const record of batches.flat()) {
        const id = this.text(record && record.id);
        if (!id) throw new Error('Shelter record ID is missing');
        seen.set(id, record);
      }
      if (seen.size !== first.total) throw new Error('The shelter record list is incomplete');
      return [...seen.values()];
    }

    static loadAll(seed, context, fresh = false) {
      const url = new URL(context.url);
      url.hash = '';
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.searchParams.delete(seed.page_param);
      const key = `${seed.version}|${context.type}|${url.href}`;
      const cached = this.feeds.get(key);
      // On a theme-editor reload, re-read data. Concurrent instances still share work.
      if (cached && (!fresh || !cached.settled)) return cached.promise;
      const entry = { promise: null, settled: false };
      entry.promise = this.collect(seed, context).then(records => {
        entry.settled = true;
        return records;
      }).catch(error => {
        if (this.feeds.get(key) === entry) this.feeds.delete(key);
        throw error;
      });
      this.feeds.set(key, entry);
      return entry.promise;
    }

    static groups(records, mode, asOfDate) {
      const shelters = new Map();
      const cutoff = this.validDate(asOfDate) ? this.text(asOfDate) : '';
      const cutoffMonth = cutoff.slice(0, 7);
      records.forEach(record => {
        if (!record) return;
        const donationDate = this.validDate(record.donation_date) ? this.text(record.donation_date) : '';
        const enteredMonth = this.validMonth(record.month) ? this.text(record.month) : '';
        // Month is authoritative. Existing exact dates remain an optional fallback.
        const month = enteredMonth || (donationDate && (!cutoff || donationDate <= cutoff) ? donationDate.slice(0, 7) : '');
        if (!month || (cutoffMonth && month > cutoffMonth)) return;
        const recordId = this.text(record.id);
        const source = record.shelter || {};
        const id = this.text(source.id);
        const name = this.text(source.name);
        const facebook = this.safeURL(source.facebook);
        const supplies = this.text(record.supplies);
        if (!recordId || !id || !name || !facebook || !supplies) return;
        const sortDate = month;
        const existing = shelters.get(id);
        if (existing && (sortDate < existing.sortDate || (sortDate === existing.sortDate && recordId <= existing.latestRecordId))) return;
        const orderText = this.text(record.display_order);
        const parsedOrder = /^-?\d+$/.test(orderText) ? Number(orderText) : NaN;
        const displayOrder = Number.isFinite(parsedOrder) ? Math.max(-999999999, Math.min(999999999, parsedOrder)) : 999999999;
        shelters.set(id, {
          id, name, facebook, website: this.safeURL(source.website), avatar: this.safeURL(source.avatar),
          summary: this.text(source.summary), latestDate: donationDate,
          latestMonth: month, displayOrder,
          latestSupplies: supplies, latestRecordId: recordId, sortDate
        });
      });
      return [...shelters.values()].map(group => ({
        ...group,
        donationText: mode === 'recent' ? group.latestSupplies : (group.summary || group.latestSupplies),
        searchName: this.normalize(group.name)
      }));
    }

    static orderRows(rows, order) {
      return [...rows].sort((a, b) => {
        if (order === 'recent') {
          if (a.sortDate !== b.sortDate) return b.sortDate.localeCompare(a.sortDate);
          if (a.displayOrder !== b.displayOrder) return a.displayOrder - b.displayOrder;
          const recordOrder = b.latestRecordId.localeCompare(a.latestRecordId);
          if (recordOrder) return recordOrder;
        }
        return this.collator.compare(a.name, b.name) || a.id.localeCompare(b.id);
      });
    }

    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.generation = (this.generation || 0) + 1;
      this.events = new AbortController();
      try {
        this.config = JSON.parse(this.querySelector('[data-ksl-config]').textContent);
        this.seed = JSON.parse(this.querySelector('[data-ksl-feed]').textContent);
        this.list = this.querySelector('[data-ksl-list]');
        this.status = this.querySelector('[data-ksl-status]');
        this.empty = this.querySelector('[data-ksl-empty]');
        this.more = this.querySelector('[data-ksl-more]');
        this.retry = this.querySelector('[data-ksl-retry]');
        this.search = this.querySelector('[data-ksl-search]');
        this.sort = this.querySelector('[data-ksl-sort]');
        this.fallback = this.querySelector('[data-ksl-fallback]');
        this.media = window.matchMedia('(max-width: 749px)');
        this.query = '';
        this.order = this.config.mode === 'all' && this.config.defaultSort !== 'recent' ? 'name' : 'recent';
        if (this.sort) this.sort.value = this.order;
        this.visibleCount = this.pageSize();
        this.expanded = false;
        this.loaded = false;
        this.records = this.seed.entries || [];
        this.more.addEventListener('click', () => {
          const firstNewRow = this.visibleCount;
          this.visibleCount += this.pageSize();
          this.expanded = true;
          this.render();
          const link = this.list.children[firstNewRow] && this.list.children[firstNewRow].querySelector('.ksl-avatar-link');
          if (link) link.focus({ preventScroll: true });
        }, { signal: this.events.signal });
        this.retry.addEventListener('click', () => this.load(true), { signal: this.events.signal });
        if (this.search) this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => {
            if (!this.active) return;
            this.query = KipritiiShelterList.normalize(this.search.value);
            this.visibleCount = this.pageSize();
            this.expanded = false;
            this.render();
          }, 150);
        }, { signal: this.events.signal });
        if (this.sort) this.sort.addEventListener('change', () => {
          this.order = this.sort.value;
          this.visibleCount = this.pageSize();
          this.expanded = false;
          this.render();
        }, { signal: this.events.signal });
        this.onMediaChange = () => {
          this.visibleCount = this.expanded ? Math.max(this.visibleCount, this.pageSize()) : this.pageSize();
          this.render();
        };
        if (this.media.addEventListener) this.media.addEventListener('change', this.onMediaChange);
        else if (this.media.addListener) this.media.addListener(this.onMediaChange);
        this.setAttribute('data-enhanced', '');
        this.render();
        this.load(Boolean(this.config.editor));
      } catch (_) {
        this.removeAttribute('data-enhanced');
        const fallback = this.querySelector('[data-ksl-fallback]');
        if (fallback) fallback.hidden = false;
      }
    }

    disconnectedCallback() {
      this.active = false;
      this.generation = (this.generation || 0) + 1;
      clearTimeout(this.searchTimer);
      if (this.events) this.events.abort();
      if (this.media && this.onMediaChange) {
        if (this.media.removeEventListener) this.media.removeEventListener('change', this.onMediaChange);
        else if (this.media.removeListener) this.media.removeListener(this.onMediaChange);
      }
    }

    pageSize() {
      const mobile = Boolean(this.media && this.media.matches);
      return Math.max(1, Number(mobile ? this.config.mobileCount : this.config.desktopCount) || (mobile ? 6 : 9));
    }

    async load(fresh) {
      const generation = ++this.generation;
      this.loaded = false;
      this.status.textContent = this.config.labels.loading;
      this.retry.hidden = true;
      this.fallback.hidden = true;
      this.setAttribute('aria-busy', 'true');
      if (this.search) this.search.disabled = true;
      if (this.sort) this.sort.disabled = true;
      this.more.hidden = true;
      try {
        const records = await KipritiiShelterList.loadAll(this.seed, {
          type: this.seed.type, sectionId: this.config.sectionId, url: window.location.href
        }, fresh);
        if (!this.active || generation !== this.generation) return;
        this.records = records;
        this.loaded = true;
        this.setAttribute('aria-busy', 'false');
        if (this.search) this.search.disabled = false;
        if (this.sort) this.sort.disabled = false;
        this.render();
      } catch (_) {
        if (!this.active || generation !== this.generation) return;
        this.setAttribute('aria-busy', 'false');
        this.status.textContent = this.config.labels.error;
        this.retry.hidden = false;
        this.fallback.hidden = false;
        this.empty.hidden = true;
      }
    }

    link(href, className, label) {
      const element = document.createElement('a');
      element.className = className;
      element.href = href;
      element.setAttribute('aria-label', this.config.newTab ? `${label} (${this.config.labels.newTab})` : label);
      if (this.config.newTab) {
        element.target = '_blank';
        element.rel = 'noopener noreferrer';
      }
      return element;
    }

    makeRow(row) {
      const item = document.createElement('li');
      item.className = row.website ? 'ksl-row ksl-row--website' : 'ksl-row';
      item.dataset.shelterId = row.id;
      const avatarLink = this.link(row.facebook, 'ksl-avatar-link', `${row.name} — Facebook`);
      avatarLink.title = `${row.name} — Facebook`;
      const avatar = document.createElement('span');
      avatar.className = 'ksl-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = Array.from(row.name)[0].toUpperCase();
      if (row.avatar) {
        const img = document.createElement('img');
        img.src = row.avatar;
        img.alt = '';
        img.width = 160;
        img.height = 160;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.addEventListener('error', () => img.remove(), { once: true });
        avatar.append(img);
      }
      avatarLink.append(avatar);
      const identity = document.createElement('div');
      identity.className = 'ksl-identity';
      const name = this.link(row.facebook, 'ksl-name-link', `${row.name} — Facebook`);
      name.title = `${row.name} — Facebook`;
      name.textContent = row.name;
      identity.append(name);
      const donation = document.createElement('div');
      donation.className = 'ksl-donation';
      const supplies = document.createElement('span');
      supplies.className = 'ksl-supplies';
      supplies.textContent = row.donationText;
      donation.append(supplies);
      if ((this.config.mode === 'recent' && this.config.showDonationDate) || (this.config.mode === 'all' && this.config.showLastSupported)) {
        const last = document.createElement('time');
        last.className = 'ksl-last-supported';
        last.dateTime = row.latestMonth;
        const display = KipritiiShelterList.dateLabel('', row.latestMonth);
        last.textContent = this.config.mode === 'recent' ? display : `${this.config.labels.lastSupported} ${display}`;
        donation.append(last);
      }
      item.append(avatarLink, identity, donation);
      if (row.website) {
        const website = this.link(row.website, 'ksl-button ksl-website', `${row.name} — ${this.config.labels.website}`);
        website.textContent = this.config.labels.website;
        item.append(website);
      }
      return item;
    }

    render() {
      let rows = KipritiiShelterList.groups(this.records, this.config.mode, this.config.asOfDate);
      rows = KipritiiShelterList.orderRows(rows, this.order);
      if (this.config.mode === 'all' && this.query) rows = rows.filter(row => row.searchName.includes(this.query));
      const recentReady = this.loaded || Number(this.seed.pages) <= 1;
      const shown = this.config.mode === 'recent'
        ? (recentReady ? rows.slice(0, Math.max(1, Number(this.config.recentCount) || 11)) : [])
        : rows.slice(0, this.visibleCount);
      const fragment = document.createDocumentFragment();
      shown.forEach(row => fragment.append(this.makeRow(row)));
      this.list.replaceChildren(fragment);
      this.empty.hidden = !this.loaded || rows.length > 0;
      this.empty.textContent = this.config.mode === 'all' && this.query ? this.config.labels.noMatches : this.config.labels.empty;
      this.more.hidden = !this.loaded || this.config.mode !== 'all' || shown.length >= rows.length;
      if (this.loaded) {
        this.status.textContent = this.config.mode === 'all' && this.query
          ? `${rows.length} ${this.config.labels.results}`
          : (this.config.showCount && rows.length ? `${shown.length} / ${rows.length} ${this.config.labels.shelters}` : '');
      }
    }
  }

  customElements.define('kipritii-shelter-list', KipritiiShelterList);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giving-shelters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kipritii-shelter-marquee')) {
    customElements.define('kipritii-shelter-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('.giving-shelters__viewport');
        if (!this.viewport) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileView = window.matchMedia('(max-width: 749px)');
        this.enabled = this.dataset.scrollEnabled === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.direction = this.dataset.direction === 'right' ? -1 : 1;
        this.hovered = false;
        this.linkFocused = false;
        this.userPaused = false;
        this.gesturePaused = false;
        this.pointerDown = false;
        this.editorBlockSelected = false;
        this.inView = !('IntersectionObserver' in window);
        this.frame = null;
        this.resumeTimer = null;
        this.lastTimestamp = null;
        this.cycleWidth = 0;
        this.position = 0;
        this.tick = this.tick.bind(this);

        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') {
            this.hovered = true;
            this.refreshMotion();
          }
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.refreshMotion();
        }, { signal });
        this.addEventListener('focusin', event => {
          this.linkFocused = event.target !== this.viewport;
          this.refreshMotion();
          const item = event.target.closest('.giving-shelters__item');
          if (item) this.revealItem(item);
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.controller || !this.isConnected) return;
            this.linkFocused = this.contains(document.activeElement) && document.activeElement !== this.viewport;
            this.syncPosition();
            this.refreshMotion();
          });
        }, { signal });
        this.viewport.addEventListener('pointerdown', () => {
          this.pointerDown = true;
          this.gesturePaused = true;
          clearTimeout(this.resumeTimer);
          this.refreshMotion();
        }, { passive: true, signal });
        const releasePointer = () => {
          if (!this.pointerDown) return;
          this.pointerDown = false;
          this.scheduleResume();
        };
        window.addEventListener('pointerup', releasePointer, { passive: true, signal });
        window.addEventListener('pointercancel', releasePointer, { passive: true, signal });
        this.viewport.addEventListener('wheel', event => {
          if (!event.deltaX && !event.shiftKey) return;
          this.gesturePaused = true;
          this.refreshMotion();
          this.scheduleResume();
        }, { passive: true, signal });
        this.viewport.addEventListener('scroll', () => {
          if (this.gesturePaused && !this.pointerDown) this.scheduleResume();
        }, { passive: true, signal });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            this.userPaused = !this.userPaused;
            this.syncPosition();
            this.refreshMotion();
            return;
          }
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.userPaused = true;
          this.refreshMotion();
          const items = this.originalItems();
          if (!items.length) return;
          const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
          const step = items[0].getBoundingClientRect().width + gap;
          let left = this.viewport.scrollLeft;
          if (event.key === 'ArrowLeft') left -= step;
          if (event.key === 'ArrowRight') left += step;
          if (event.key === 'Home') left = 0;
          if (event.key === 'End') left = items[items.length - 1].offsetLeft - items[0].offsetLeft;
          this.viewport.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
          this.syncPosition();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const item = this.findBlock(event.detail && event.detail.blockId);
          if (!item) return;
          this.editorBlockSelected = true;
          this.buildLoop();
          this.revealItem(item);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorBlockSelected = false;
          this.buildLoop();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.refreshMotion(), { signal });
        this.reducedMotion.addEventListener('change', () => this.buildLoop(), { signal });
        this.mobileView.addEventListener('change', () => this.buildLoop(), { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.buildLoop());
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.buildLoop(), { signal });
        }
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
            this.refreshMotion();
          }, { threshold: 0.15 });
          this.intersectionObserver.observe(this);
        }
        this.buildLoop();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        this.stopMotion();
        clearTimeout(this.resumeTimer);
        this.removeCopies();
        this.controller = null;
        this.resizeObserver = null;
        this.intersectionObserver = null;
        this.resumeTimer = null;
      }

      allOriginalItems() {
        return Array.from(this.viewport.querySelectorAll('.giving-shelters__item')).filter(item => !item.hasAttribute('data-loop-copy'));
      }

      originalItems() {
        return this.allOriginalItems().filter(item => !item.hidden);
      }

      removeCopies() {
        this.viewport.querySelectorAll('[data-loop-copy]').forEach(item => item.remove());
      }

      wrap(value, width = this.cycleWidth) {
        return width > 0 ? ((value % width) + width) % width : 0;
      }

      syncPosition() {
        this.position = this.wrap(this.viewport.scrollLeft);
      }

      buildLoop() {
        if (!this.controller) return;
        const phase = this.cycleWidth > 0 ? this.wrap(this.viewport.scrollLeft) / this.cycleWidth : 0;
        this.stopMotion();
        this.removeCopies();
        const items = this.originalItems();
        const count = items.length;
        const looping = this.enabled && !this.reducedMotion.matches && !this.editorBlockSelected && count > 1;
        this.viewport.classList.toggle('giving-shelters__viewport--fits-desktop', !looping && count <= Number(this.dataset.desktopVisible || 6));
        this.viewport.classList.toggle('giving-shelters__viewport--fits-tablet', !looping && count <= 4);
        this.viewport.classList.toggle('giving-shelters__viewport--fits-mobile', !looping && count <= 2);
        if (!looping || !this.viewport.clientWidth) {
          this.cycleWidth = 0;
          this.position = 0;
          this.viewport.scrollLeft = 0;
          return;
        }
        const first = items[0];
        const last = items[count - 1];
        const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
        this.cycleWidth = last.offsetLeft - first.offsetLeft + last.getBoundingClientRect().width + gap;
        if (!(this.cycleWidth > 0)) return;
        const groups = Math.ceil(this.viewport.clientWidth / this.cycleWidth) + 2;
        const copies = document.createDocumentFragment();
        for (let group = 1; group < groups; group += 1) {
          items.forEach(item => {
            const copy = item.cloneNode(true);
            copy.setAttribute('data-loop-copy', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-block-id');
            copy.removeAttribute('data-shopify-editor-block');
            copy.removeAttribute('id');
            copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
              node.removeAttribute('id');
              node.removeAttribute('data-shopify-editor-block');
            });
            copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
            copy.querySelectorAll('.giving-shelters__editor-note').forEach(note => note.remove());
            copies.appendChild(copy);
          });
        }
        this.viewport.appendChild(copies);
        this.position = phase * this.cycleWidth;
        this.viewport.scrollLeft = this.position;
        this.refreshMotion();
      }

      duration() {
        const value = this.mobileView.matches ? this.dataset.durationMobile : this.dataset.duration;
        return Math.max(5, Number(value) || 40);
      }

      canMove() {
        return Boolean(this.controller && this.isConnected && this.cycleWidth > 0 && this.enabled &&
          !this.reducedMotion.matches && !this.userPaused && !this.editorBlockSelected &&
          !this.linkFocused && !this.gesturePaused && !(this.pauseOnHover && this.hovered) &&
          this.inView && !document.hidden);
      }

      stopMotion() {
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTimestamp = null;
      }

      refreshMotion() {
        if (!this.canMove()) {
          this.stopMotion();
          return;
        }
        if (this.frame === null) {
          this.syncPosition();
          this.lastTimestamp = null;
          this.frame = requestAnimationFrame(this.tick);
        }
      }

      tick(timestamp) {
        this.frame = null;
        if (!this.canMove()) {
          this.lastTimestamp = null;
          return;
        }
        if (this.lastTimestamp !== null) {
          const elapsed = Math.min(64, Math.max(0, timestamp - this.lastTimestamp));
          const distance = this.cycleWidth * elapsed / (this.duration() * 1000);
          this.position = this.wrap(this.position + this.direction * distance);
          this.viewport.scrollLeft = this.position;
        }
        this.lastTimestamp = timestamp;
        this.frame = requestAnimationFrame(this.tick);
      }

      scheduleResume() {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          this.gesturePaused = false;
          this.syncPosition();
          this.refreshMotion();
        }, 900);
      }

      revealItem(item) {
        const bounds = this.viewport.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        if (rect.left < bounds.left + 2 || rect.right > bounds.right - 2) {
          const first = this.allOriginalItems()[0];
          if (first) this.viewport.scrollTo({ left: Math.max(0, item.offsetLeft - first.offsetLeft), behavior: 'auto' });
          this.syncPosition();
        }
      }

      findBlock(id) {
        return this.allOriginalItems().find(item => item.dataset.blockId === id);
      }
    });
  }
  (() => {
    if (customElements.get('kipritii-shelter-source')) return;

    class KipritiiShelterSource extends HTMLElement {
    static feeds = new Map();
    static collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

    static text(value) {
      return value == null ? '' : String(value).trim();
    }

    static validMonth(value) {
      return /^\d{4}-(0[1-9]|1[0-2])$/.test(this.text(value));
    }

    static validDate(value) {
      const raw = this.text(value);
      if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(raw)) return false;
      const date = new Date(`${raw}T12:00:00Z`);
      return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === raw;
    }

    static dateLabel(date, month = '') {
      const normalizedDate = this.text(date);
      const normalizedMonth = this.text(month);
      const exactDate = this.validDate(normalizedDate);
      if (!exactDate && !this.validMonth(normalizedMonth)) return '';
      const value = new Date(`${exactDate ? normalizedDate : `${normalizedMonth}-01`}T12:00:00Z`);
      const options = { month: 'long', year: 'numeric', timeZone: 'UTC' };
      if (exactDate) options.day = 'numeric';
      return new Intl.DateTimeFormat('en-US', options).format(value);
    }

    static normalize(value) {
      return this.text(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ');
    }

    static safeURL(value, base = window.location.href) {
      const raw = this.text(value);
      if (!raw || !/^(https?:\/\/|\/\/|\/)/i.test(raw)) return '';
      try {
        const url = new URL(raw, base);
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
      } catch (_) {
        return '';
      }
    }

    static validateFeed(feed, type, expectedPage) {
      if (!feed || feed.version !== 3 || feed.type !== type || !Array.isArray(feed.entries)) {
        throw new Error('Invalid shelter feed');
      }
      const page = Number(feed.page);
      const pages = Math.max(1, Number(feed.pages));
      const total = Number(feed.total);
      if (!Number.isInteger(page) || page < 1 || page !== expectedPage || !Number.isInteger(pages) || pages < page || !Number.isInteger(total) || total < 0 || !feed.page_param) {
        throw new Error('Invalid shelter pagination');
      }
      return { ...feed, page, pages, total };
    }

    static parseHTML(html, type, page) {
      const match = html.match(/<script\b(?=[^>]*\bdata-ksl-feed\b)[^>]*>([\s\S]*?)<\/script\s*>/i);
      if (!match) throw new Error('Shelter feed not found');
      return this.validateFeed(JSON.parse(match[1]), type, page);
    }

    static async fetchPage(context, page, pageParam) {
      const url = new URL(context.url);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', context.sectionId);
      url.searchParams.set(pageParam, String(page));
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Shelter page request failed');
        return this.parseHTML(await response.text(), context.type, page);
      } finally {
        clearTimeout(timer);
      }
    }

    static async collect(seed, context) {
      const first = seed.page === 1 ? this.validateFeed(seed, context.type, 1) : await this.fetchPage(context, 1, seed.page_param);
      const batches = [first.entries];
      // Fetch all record pages, including entries beyond the first 50/100.
      // The two page sections share this promise; only visible rows enter the DOM.
      for (let page = 2; page <= first.pages; page += 2) {
        const numbers = [page];
        if (page + 1 <= first.pages) numbers.push(page + 1);
        const feeds = await Promise.all(numbers.map(number => this.fetchPage(context, number, first.page_param)));
        for (const feed of feeds) {
          if (feed.total !== first.total || feed.pages !== first.pages) throw new Error('Shelter records changed while loading');
          batches.push(feed.entries);
        }
      }
      const seen = new Map();
      for (const record of batches.flat()) {
        const id = this.text(record && record.id);
        if (!id) throw new Error('Shelter record ID is missing');
        seen.set(id, record);
      }
      if (seen.size !== first.total) throw new Error('The shelter record list is incomplete');
      return [...seen.values()];
    }

    static loadAll(seed, context, fresh = false) {
      const url = new URL(context.url);
      url.hash = '';
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.searchParams.delete(seed.page_param);
      const key = `${seed.version}|${context.type}|${url.href}`;
      const cached = this.feeds.get(key);
      // On a theme-editor reload, re-read data. Concurrent instances still share work.
      if (cached && (!fresh || !cached.settled)) return cached.promise;
      const entry = { promise: null, settled: false };
      entry.promise = this.collect(seed, context).then(records => {
        entry.settled = true;
        return records;
      }).catch(error => {
        if (this.feeds.get(key) === entry) this.feeds.delete(key);
        throw error;
      });
      this.feeds.set(key, entry);
      return entry.promise;
    }

    static groups(records, mode, asOfDate) {
      const shelters = new Map();
      const cutoff = this.validDate(asOfDate) ? this.text(asOfDate) : '';
      const cutoffMonth = cutoff.slice(0, 7);
      records.forEach(record => {
        if (!record) return;
        const donationDate = this.validDate(record.donation_date) ? this.text(record.donation_date) : '';
        const enteredMonth = this.validMonth(record.month) ? this.text(record.month) : '';
        // Month is authoritative. Existing exact dates remain an optional fallback.
        const month = enteredMonth || (donationDate && (!cutoff || donationDate <= cutoff) ? donationDate.slice(0, 7) : '');
        if (!month || (cutoffMonth && month > cutoffMonth)) return;
        const recordId = this.text(record.id);
        const source = record.shelter || {};
        const id = this.text(source.id);
        const name = this.text(source.name);
        const facebook = this.safeURL(source.facebook);
        const supplies = this.text(record.supplies);
        if (!recordId || !id || !name || !facebook || !supplies) return;
        const sortDate = month;
        const existing = shelters.get(id);
        if (existing && (sortDate < existing.sortDate || (sortDate === existing.sortDate && recordId <= existing.latestRecordId))) return;
        const orderText = this.text(record.display_order);
        const parsedOrder = /^-?\d+$/.test(orderText) ? Number(orderText) : NaN;
        const displayOrder = Number.isFinite(parsedOrder) ? Math.max(-999999999, Math.min(999999999, parsedOrder)) : 999999999;
        shelters.set(id, {
          id, name, facebook, website: this.safeURL(source.website), avatar: this.safeURL(source.avatar),
          summary: this.text(source.summary), latestDate: donationDate,
          latestMonth: month, displayOrder,
          latestSupplies: supplies, latestRecordId: recordId, sortDate
        });
      });
      return [...shelters.values()].map(group => ({
        ...group,
        donationText: mode === 'recent' ? group.latestSupplies : (group.summary || group.latestSupplies),
        searchName: this.normalize(group.name)
      }));
    }

    static orderRows(rows, order) {
      return [...rows].sort((a, b) => {
        if (order === 'recent') {
          if (a.sortDate !== b.sortDate) return b.sortDate.localeCompare(a.sortDate);
          if (a.displayOrder !== b.displayOrder) return a.displayOrder - b.displayOrder;
          const recordOrder = b.latestRecordId.localeCompare(a.latestRecordId);
          if (recordOrder) return recordOrder;
        }
        return this.collator.compare(a.name, b.name) || a.id.localeCompare(b.id);
      });
    }

      static sources = new Map();

      static parseSource(html) {
        const sections = html.matchAll(/<kipritii-shelter-list\b[^>]*>([\s\S]*?)<\/kipritii-shelter-list\s*>/gi);
        for (const section of sections) {
          const configMatch = section[1].match(/<script\b(?=[^>]*\bdata-ksl-config\b)[^>]*>([\s\S]*?)<\/script\s*>/i);
          if (!configMatch) continue;
          const config = JSON.parse(configMatch[1]);
          if (config.mode !== 'recent') continue;
          if (!this.text(config.sectionId)) throw new Error('The monthly section ID is missing');
          const feedMatch = section[1].match(/<script\b(?=[^>]*\bdata-ksl-feed\b)[^>]*>([\s\S]*?)<\/script\s*>/i);
          if (!feedMatch) throw new Error('The monthly data feed is missing');
          const parsed = JSON.parse(feedMatch[1]);
          if (!this.text(parsed.type)) throw new Error('The donation type is missing');
          const seed = this.validateFeed(parsed, parsed.type, Number(parsed.page));
          return { config, seed };
        }
        throw new Error('The latest donation recipients section was not found on the selected page');
      }

      static sourceURL(value) {
        const url = new URL(value, window.location.href);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) {
          throw new Error('Select a page from this store');
        }
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        const current = new URL(window.location.href);
        for (const key of ['preview_theme_id', 'preview_key']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        return url;
      }

      static readSource(value, fresh = false) {
        const url = this.sourceURL(value);
        const cached = this.sources.get(url.href);
        if (cached && (!fresh || !cached.settled)) return cached.promise;
        const entry = { promise: null, settled: false };
        entry.promise = (async () => {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 20000);
          try {
            const response = await fetch(url.href, {
              credentials: 'same-origin', signal: controller.signal,
              cache: fresh ? 'no-store' : 'default', headers: { Accept: 'text/html' }
            });
            if (!response.ok) throw new Error('The shelter source page could not be loaded');
            if (response.url && new URL(response.url).origin !== url.origin) throw new Error('Unexpected source redirect');
            const source = this.parseSource(await response.text());
            entry.settled = true;
            return { ...source, url: url.href };
          } finally {
            clearTimeout(timer);
          }
        })().catch(error => {
          if (this.sources.get(url.href) === entry) this.sources.delete(url.href);
          throw error;
        });
        this.sources.set(url.href, entry);
        return entry.promise;
      }

      connectedCallback() {
        if (this.active) return;
        this.marquee = this.querySelector('kipritii-shelter-marquee');
        this.viewport = this.querySelector('.giving-shelters__viewport');
        this.status = this.querySelector('[data-gsh-sync-status]');
        this.fallback = this.querySelector('[data-gsh-sync-fallback]');
        this.retry = this.querySelector('[data-gsh-sync-retry]');
        if (!this.marquee || !this.viewport || !this.status || !this.fallback || !this.retry) return;
        this.active = true;
        this.generation = (this.generation || 0) + 1;
        this.events = new AbortController();
        this.retry.addEventListener('click', () => this.load(true), { signal: this.events.signal });
        this.load(this.dataset.editor === 'true');
      }

      disconnectedCallback() {
        this.active = false;
        this.generation = (this.generation || 0) + 1;
        if (this.events) this.events.abort();
      }

      makeRow(row) {
        const item = document.createElement('li');
        item.className = `giving-shelters__item ${this.dataset.textClass || ''}`;
        item.dataset.shelterId = row.id;
        const identity = document.createElement('a');
        identity.className = 'giving-shelters__identity';
        identity.href = row.facebook;
        identity.title = row.name;
        let label = `${row.name} — Facebook page`;
        if (this.dataset.newTab === 'true') {
          identity.target = '_blank';
          identity.rel = 'noopener noreferrer';
          label += ' (opens in a new tab)';
        }
        identity.setAttribute('aria-label', label);
        const avatar = document.createElement('span');
        avatar.className = `giving-shelters__avatar ${this.dataset.avatarPalette || ''}`;
        avatar.setAttribute('aria-hidden', 'true');
        const paw = this.querySelector('[data-gsh-paw]');
        if (row.avatar) {
          const image = document.createElement('img');
          image.className = 'giving-shelters__logo';
          image.src = row.avatar;
          image.alt = '';
          image.width = 240;
          image.height = 240;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.addEventListener('error', () => {
            image.remove();
            if (paw) avatar.append(paw.content.cloneNode(true));
          }, { once: true });
          avatar.append(image);
        } else if (paw) {
          avatar.append(paw.content.cloneNode(true));
        }
        const name = document.createElement('h3');
        name.className = `giving-shelters__name ${this.dataset.nameClass || ''}`;
        name.textContent = row.name;
        identity.append(avatar, name);
        item.append(identity);
        return item;
      }

      async load(fresh = false) {
        const generation = ++this.generation;
        this.setAttribute('aria-busy', 'true');
        this.status.hidden = false;
        this.status.textContent = 'Loading recent shelters…';
        this.fallback.hidden = true;
        this.retry.hidden = true;
        if (typeof this.marquee.stopMotion === 'function') this.marquee.stopMotion();
        this.viewport.hidden = true;
        try {
          const source = await KipritiiShelterSource.readSource(this.dataset.sourceUrl, fresh);
          const records = await KipritiiShelterSource.loadAll(source.seed, {
            type: source.seed.type, sectionId: source.config.sectionId, url: source.url
          }, fresh);
          if (!this.active || generation !== this.generation) return;
          const rows = KipritiiShelterSource.orderRows(
            KipritiiShelterSource.groups(records, 'recent', source.config.asOfDate), 'recent'
          ).slice(0, Math.max(1, Number(source.config.recentCount) || 11));
          const fragment = document.createDocumentFragment();
          rows.forEach(row => fragment.append(this.makeRow(row)));
          this.viewport.replaceChildren(fragment);
          this.setAttribute('aria-busy', 'false');
          if (!rows.length) {
            this.status.textContent = 'Recent donation updates will appear here.';
            this.fallback.hidden = false;
            return;
          }
          this.viewport.hidden = false;
          this.status.textContent = '';
          this.status.hidden = true;
          await customElements.whenDefined('kipritii-shelter-marquee');
          if (!this.active || generation !== this.generation) return;
          this.marquee.cycleWidth = 0;
          this.marquee.position = 0;
          this.viewport.scrollLeft = 0;
          if (typeof this.marquee.buildLoop === 'function') this.marquee.buildLoop();
        } catch (_) {
          if (!this.active || generation !== this.generation) return;
          this.setAttribute('aria-busy', 'false');
          this.status.textContent = 'Explore our latest shelter updates below.';
          this.fallback.hidden = false;
          this.retry.hidden = false;
        }
      }
    }

    customElements.define('kipritii-shelter-source', KipritiiShelterSource);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
